import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postRequest } from "../../apis/ApiInstence"; // Make sure this file and function exist

const CheckoutPage = () => {
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart?.cartItems || []);

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + (item.fees || item.fee) * item.quantity,
    0
  );

  const handlePlaceOrder = async () => {
    try {
      const payload = {
        items: cartItems,
        totalAmount,
        paymentMode: "Cash on Delivery",
        orderDate: new Date().toISOString(),
      };

      const response = await postRequest("order", payload);
      if (response?.success) {
        navigate("/thank-you");
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      toast.error("Failed to place order");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Checkout</h2>

      <div className="bg-white shadow-md rounded p-6">
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Payment Mode
          </label>
          <select
            className="border rounded px-3 py-2 w-full"
            disabled
          >
            <option value="cod">Cash on Delivery</option>
          </select>
        </div>

        <div className="mt-6 text-right">
          <p className="text-lg font-semibold mb-4">
            Total Amount: ₹{totalAmount.toFixed(2)}
          </p>
          <button
            onClick={handlePlaceOrder}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
          >
            Place Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
